import {Component, OnInit, Input} from '@angular/core';
import {ViewCell} from "ng2-smart-table";
import {RouterModule} from '@angular/router';
@Component({
	// selector: 'action-button-view',
	// template: '<button (click)="showAlert()">{{ renderValue }}</button>',
    // template:`<a [routerLink]="['/newassessment', someId]" routerLinkActive="active" 
    // [routerLinkActiveOptions]="{exact: true}"
    // >{{ linkText }}</a>`,

    template: `<a [routerLink]="['/newassessment', someId]" routerLinkActive="active" 
    [routerLinkActiveOptions]="{exact: true}"
    >{{ linkText }}</a>`,
})

export class CellDataRenderComp_Assess implements ViewCell, OnInit {

    public linkText: string;
  public someId: number;

  @Input()
  public value: string;

  @Input()
  rowData: any;

    ngOnInit(){
        this.linkText = this.value;        
    this.someId= this.rowData.ARef_Home;
    }
}


